module.exports = __webpack_public_path__ + "static/media/stenobothrus_stigmaticus_003_APA.cb095cda.mp3";